import PageModule from "@insite/client-framework/Types/PageModule";
import { withToaster } from "@insite/mobius/Toast/ToasterContext";
import { withHistory } from "@insite/mobius/utilities/HistoryContext";
import { ConnectedAnnouncementList, ConnectedHeader } from "@sonic-equipment/ui";

import * as React from "react";

const enum fields {
    homePageHeaderHeight = "homePageHeaderHeight",
    homePageHeaderScrollPosition = "homePageHeaderScrollPosition",
    regularHeaderHeight = "regularHeaderHeight",
    regularHeaderScrollPosition = "regularHeaderScrollPosition",
    headerPrintImage = "headerPrintImage",
}

export const Header: React.FC = () => {
    return (
        <>
            <ConnectedAnnouncementList className="v2" />
            <ConnectedHeader source="shop" className="v2" />
        </>
    );
};

const pageModule: PageModule = {
    component: withToaster(withHistory(Header)),
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
        fieldDefinitions: [
            {
                name: fields.homePageHeaderHeight,
                editorTemplate: "IntegerField",
                displayName: "Home Page Header: Height",
                defaultValue: 136,
                fieldType: "General",
                isRequired: true,
            },
            {
                name: fields.homePageHeaderScrollPosition,
                editorTemplate: "IntegerField",
                displayName: "Home Page Header: Scroll Position Toggle",
                defaultValue: 250,
                fieldType: "General",
                isRequired: true,
            },
            {
                name: fields.regularHeaderHeight,
                editorTemplate: "IntegerField",
                displayName: "Page Header: Height",
                defaultValue: 232,
                fieldType: "General",
                isRequired: true,
            },
            {
                name: fields.regularHeaderScrollPosition,
                editorTemplate: "IntegerField",
                displayName: "Page Header: Scroll Position Toggle",
                defaultValue: 0,
                fieldType: "General",
                isRequired: true,
            },
            {
                name: fields.headerPrintImage,
                displayName: "Header Print Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export const HeaderContext = "HeaderContext";

export default pageModule;
